import React from 'react';
import { Box, Typography, Button, ButtonGroup, Paper } from '@mui/material';

export default function DateRangeFilter({
  dateFilter,
  setDateFilter,
  customStart,
  setCustomStart,
  customEnd,
  setCustomEnd,
}) {
  return (
    <Paper elevation={0} sx={{ p: 2, borderRadius: 2, border: '1px solid', borderColor: 'divider' }}>
      <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
        Date range
      </Typography>
      <ButtonGroup variant="outlined" size="small" sx={{ flexWrap: 'wrap' }}>
        <Button
          onClick={() => setDateFilter('week')}
          color={dateFilter === 'week' ? 'primary' : 'inherit'}
          variant={dateFilter === 'week' ? 'contained' : 'outlined'}
        >
          Week
        </Button>
        <Button
          onClick={() => setDateFilter('month')}
          color={dateFilter === 'month' ? 'primary' : 'inherit'}
          variant={dateFilter === 'month' ? 'contained' : 'outlined'}
        >
          Month
        </Button>
        <Button
          onClick={() => setDateFilter('date')}
          color={dateFilter === 'date' ? 'primary' : 'inherit'}
          variant={dateFilter === 'date' ? 'contained' : 'outlined'}
        >
          Date
        </Button>
      </ButtonGroup>
      {dateFilter === 'date' && (
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mt: 2, flexWrap: 'wrap' }}>
          <Typography variant="body2">From</Typography>
          <input
            type="date"
            value={customStart}
            onChange={(e) => setCustomStart(e.target.value)}
            style={{ padding: '6px 10px', borderRadius: 4, border: '1px solid #ccc' }}
          />
          <Typography variant="body2">To</Typography>
          <input
            type="date"
            value={customEnd}
            onChange={(e) => setCustomEnd(e.target.value)}
            style={{ padding: '6px 10px', borderRadius: 4, border: '1px solid #ccc' }}
          />
        </Box>
      )}
    </Paper>
  );
}
